import type * as ents from '@attain-apps/entities'
import * as graphql from '@attain-apps/fe/web/main/lib/graphql'
import * as transformers from '@attain-apps/transformers'
import { TypeAsserter } from '@attain-apps/type-guards'
import gql from 'graphql-tag'

const DOC = gql`
  query Zones($tenantId: ID!, $ids: [ID!], $quantity: Int, $cursor: String) {
    tenant(id: $tenantId) {
      zones(ids: $ids, quantity: $quantity, cursor: $cursor) {
        items {
          id
          alias
          code
          description
          name
          createdBy
        }
        nextCursor
      }
    }
  }
`

const TRANSFORMER = graphql.transformers.OUT.default(
  graphql.transformers.OUT.select<
    graphql.schema.ZonesQuery,
    ents.core.common.Response.For.Pagination<ents.core.admin.Zone>,
    'tenant'
  >(
    'tenant',
    graphql.transformers.OUT.select(
      'zones',
      graphql.transformers.OUT.object({
        items: graphql.transformers.OUT.default(
          graphql.transformers.OUT.list(
            graphql.transformers.OUT.object({
              alias: graphql.transformers.OUT.validate(
                transformers.PASS_THROUGH,
                TypeAsserter.assertIsNotNullish,
                {
                  warnOnly: true,
                },
              ),
              code: graphql.transformers.OUT.validate(
                transformers.PASS_THROUGH,
                TypeAsserter.assertIsNotNullish,
                {
                  warnOnly: true,
                },
              ),
              description: transformers.PASS_THROUGH,
              createdBy: transformers.PASS_THROUGH,
              id: graphql.transformers.OUT.validate(
                transformers.PASS_THROUGH,
                TypeAsserter.assertIsNotNullish,
                {
                  warnOnly: true,
                },
              ),
              name: graphql.transformers.OUT.validate(
                transformers.PASS_THROUGH,
                TypeAsserter.assertIsNotNullish,
                {
                  warnOnly: true,
                },
              ),
            }),
            {
              onNullish: 'remove',
            },
          ),
          [],
        ),
        nextCursor: transformers.PASS_THROUGH,
      }),
    ),
  ),
  {
    items: [],
    nextCursor: undefined,
  },
)

export const execute = graphql.createExecutor<
  graphql.schema.ZonesQuery,
  ents.core.common.Response.For.Pagination<ents.core.admin.Zone>,
  graphql.schema.ZonesQueryVariables
>({
  query: DOC,
  transformer: TRANSFORMER,
})
